<svg width="28" height="28" viewBox="0 0 27 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g filter="url(#filter0_f_953_14759)">
<path d="M18.8892 19.561C20.1176 19.561 21.5462 19.7463 22.9499 20L23 16L4 16.5366V19.5512C7.08641 19.5733 15.8083 19.561 18.8892 19.561Z" fill="#969696" fill-opacity="0.37"/>
</g>
<path d="M4 20V0H24V15.5276C24 17.0352 23.75 18.6432 23.75 18.6432C23.75 18.6432 21.85 20 18.1 20H4Z" fill="currentColor"/>
<path d="M4 20V0H24V15.5276C24 17.0352 23.75 18.6432 23.75 18.6432C23.75 18.6432 21.85 20 18.1 20H4Z" fill="url(#paint0_linear_953_14759)" fill-opacity="0.1"/>
<defs>
<filter id="filter0_f_953_14759" x="0" y="12" width="27" height="12" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
<feFlood flood-opacity="0" result="BackgroundImageFix"/>
<feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
<feGaussianBlur stdDeviation="2" result="effect1_foregroundBlur_953_14759"/>
</filter>
<linearGradient id="paint0_linear_953_14759" x1="24" y1="19.5477" x2="19.9891" y2="17.1033" gradientUnits="userSpaceOnUse">
<stop/>
<stop offset="1" stop-opacity="0"/>
</linearGradient>
</defs>
</svg>
